// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__nx8CR","body":"style__body__Q6r3d","footer":"style__footer__rDThd"};